import { getAllNutritionsists, getAllClients } from '../api'

export const getNutritionists = async ({ commit, dispatch }, { page, pageSize }) => {
  try {
    const res = await getAllNutritionsists(page, pageSize)
    if (res && res instanceof Error) throw res
    commit('DIETITIANS', { data: res.data.results, total: res.data.total, page: res.data.page, pageSize: res.data.pageSize })
  } catch (err) {
    commit('TOAST_ERROR', err.toast)
    return false
  }
}

export const getClients = async ({ commit, dispatch, getters }, { page, pageSize }) => {
  try {
    const res = await getAllClients(getters.currentDietitian, page, pageSize)
    if (res && res instanceof Error) throw res
    commit('RESET_NEW_USER')
    commit('USERS', { data: res.data.results, total: res.data.total, page: res.data.page, pageSize: res.data.pageSize })
  } catch (err) {
    commit('TOAST_ERROR', err.toast)
    return false
  }
}

export const setDietitian = ({ commit, dispatch }, data) => {
  commit('SET_DIETITIAN', data)
}



// WEBPACK FOOTER //
// ./src/app/store/dietitians/actions.js